import React, { useEffect, useState } from "react";
import { getData, insertData, insertDataJson } from "../Tools/helpers";
import FinancialSummary from "../Admin/Franchises/FinancialSummary";
import FinancialSummaryFranchise from "../Admin/Franchises/FinancialSummaryFranchise";
import PaymentModal from "./ModalPayment";
import { Alert } from "@mui/material";
import LogoSep from '../../../src/logo_sep.png';

const FranchiseSummary = () => {
  const [universityID, setUniversityID] = useState(null);
  const [accountStatements, setAccountStatements] = useState({});
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [globalSummary, setGlobalSummary] = useState({});
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [isPaymentReinscription, setIsPaymentReinscription] = useState(false);
  const [payments, setPayments] = useState([]);
  const [students, setStudents] = useState([]);

  const [messageGeneral, setMessageGeneral] = useState({
    status: false,
    message: "",
    label: "",
  });

  const [message, setMessage] = useState({
    status: false,
    message: "",
    label: "",
  });

  const getUser = async() => {
    return await JSON.parse(localStorage.getItem("USER_IUMV"));
  }

  const handlePaymentSubmit = async (paymentData) => {
    
    const formData = new FormData();
    formData.append('amount', paymentData.amount);
    formData.append('remaining', paymentData.remaining);
    formData.append('credit_balance', 0);
    formData.append('credit_balance_amount', 0);
    formData.append('date', paymentData.date);
    formData.append('reference', paymentData.reference);
    formData.append('type', paymentData.type);
    formData.append('module', paymentData.module);
    formData.append('evidence', paymentData.proof);
    formData.append('university_id', universityID);
    formData.append('invoice_id', selectedInvoice);

    const send = await insertData('Franchise-Payment', formData);
    if (send.code === 201) {
      setMessage({
        status: true,
        message: "Se ha registrado el pago correctamente",
        label: "success",
      });
      getAccountStatements();
      getGlobalSummary();
      getPayments();
      setTimeout(()=>{
        setShowPaymentModal(false);
      }, 1500)
      return;
    }

    if(send.status === "error"){
      setMessage({
        status: true,
        message: send.message,
        label: "error",
      });
      return;
    }
    setMessage({
      status: true,
      message: "Ha ocurrido algo y no se realizó el pago",
      label: "error",
    });

  };


  const paymentMercadoPago = async (infoPayment) => {
    const route = "Franchise-Payment-Reference";
    const newData = {
      ...infoPayment,
      university_id: universityID,
      invoice_id: selectedInvoice
    }
    const send = await insertDataJson(route, newData);
    
    if(send.data?.init_point){
      window.location.href = send.data.init_point;
      setMessage({
        status: true,
        message: "Redireccionando...",
        label: "info",
      });
      return;
    }

    if (send.status === 'error') {
        setMessage({
          status: true,
          message: send.message || "No se realizó la transancción",
          label: "error",
        });
        return;        
      }
    
      setMessage({
        status: true,
        message: "No se realizó la transancción",
        label: "error",
      });
  };

  const getGlobalSummary = async () => {
    setMessageGeneral({
      status: true,
      message: "Consultando...",
      label: "info",
    });
    const User = await getUser();
    const route = `Franchise-Invoice-General/${User.university_id}`;
    const send = await getData(route);
    if (send.code === 200) {
      setGlobalSummary(send.data);
      setMessageGeneral({
        status: true,
        message: "Consulta exitosa",
        label: "success",
      });
      return;
    }
    setMessageGeneral({
      status: true,
      message: "No se pudo cargar la información",
      label: "error",
    });
  };
  

  const getAccountStatements = async () => {
    const User = await getUser();
    const route = `Franchise-Invoice/${User.university_id}`;
    const send = await getData(route);
    if (send.code === 200) {
      setUniversityID(User.university_id);
      setAccountStatements(send.data.history);
      setSelectedMonth(send.data.actual_period);
    }
  };

  const getPayments = async () => {
    const User = await getUser();
    const route = `Franchise-Payment/${User.university_id}`;
    const send = await getData(route);
    if (send.code === 200) {
      setPayments(send.data);
    }
  };

  const getStudents = async () => {
    const User = await getUser();
    const route = `Franchise-Student/${User.university_id}`;
    const send = await getData(route);
    if (send.code === 200) {
      setStudents(send.data);
    }
  };

  useEffect(() => {
    getAccountStatements();
    getGlobalSummary();
    getPayments();
    getStudents();
  }, []);

  useEffect(()=>{
    setSelectedInvoice(accountStatements[selectedMonth]?.summary?.invoice_id)
  },[selectedMonth])

  
  return (
    <div className="mt-12 pb-12">

      {showPaymentModal && (
        <PaymentModal
          onClose={() => setShowPaymentModal(false)}
          onPaymentSubmit={handlePaymentSubmit}
          paymentMercadoPago={paymentMercadoPago}
          selectedMonth={selectedMonth}
          accountStatements={accountStatements} 
          message={message}
          students = {students}
          isPaymentReinscription = {isPaymentReinscription}
        />
      )}
      
      <div className="bg-white px-10 py-5 mb-5">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">DEUDA GENERAL</h1>
        <div className='m-2'>
        {messageGeneral.status ? (
            <Alert className="mt-2" severity={messageGeneral.label}>
              {messageGeneral.message}
            </Alert>
          ) : (
            ""
          )}
        </div>
        <FinancialSummary globalSummary={globalSummary} />
      </div>
      <div className="bg-white px-10 py-5">
        <h1 className="mt-5 text-2xl font-bold mb-6 text-gray-800">MENSUAL <small className="text-gray-500">{selectedMonth}</small></h1>
        <div className="flex flex-1 justify-end">
          {
            isPaymentReinscription ?
              <button
                className={`
                    px-10 py-2 bg-red-600 hover:bg-red-700
                    text-white rounded `
                  }
                  onClick={()=>setShowPaymentModal(true)}
                > 
                <i className=" px-2 mr-2 text-white fas fa-credit-card"></i>
                PAGAR REINSCRIPCIÓN
              </button>
            :
              <button
                className={`
                  px-10 py-2 
                  ${accountStatements[selectedMonth]?.summary?.status === "Pagado" || accountStatements[selectedMonth]?.previous_debt === 'true' ? ' bg-slate-600' : ' bg-red-600 hover:bg-red-700'}
                  text-white rounded `
                }
                onClick={()=>setShowPaymentModal(true)}
                disabled = {accountStatements[selectedMonth]?.summary?.status === "Pagado" || accountStatements[selectedMonth]?.previous_debt === 'true' ? true : false}
              > 
              <i className=" px-2 mr-2 text-white fas fa-credit-card"></i>
              PAGAR
              </button>
          }
        </div>
        <div className=' justify-end text-right pt-3'>
          {
            accountStatements[selectedMonth]?.previous_debt === 'true' ?
              <label className='text-red-600'>
                *Debe liquidar el mes anterior
              </label>
            : null
          }
        </div>
        <FinancialSummaryFranchise 
          selectedMonth={selectedMonth}
          setSelectedMonth={setSelectedMonth} 
          accountStatements={accountStatements} 
          payments = {payments}
          showActions = {false}
          students = {students}
          setIsPaymentReinscription = {setIsPaymentReinscription}
        />
      </div>
      <div className="text-center flex justify-center bg-white">
        <img src={LogoSep} width={300} />
      </div>
    </div>
  );
};

export default FranchiseSummary;
